export default "/_next/static/images/Mediterranean-d4a93040b0c5d9d07623e0dc7bf2fc32.png";